var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Datetime from 'react-datetime';
import PropTypes from 'prop-types';
import 'moment/locale/ru';
import 'moment/locale/en-gb';
import 'moment/locale/uz-latn';
import { getMomentLocale } from '../../shared/momentLocale';
var Datepicker = function (props) {
    var locale = getMomentLocale(props.languageId);
    return (_jsx("div", __assign({ className: 'datapicker' }, { children: _jsx(Datetime, { timeFormat: false, locale: locale, className: 'calendar', inputProps: { readOnly: true }, closeOnSelect: true, onChange: props.onDateChange, readonly: true }) })));
};
Datepicker.propTypes = {
    onDateChange: PropTypes.func.isRequired,
    languageId: PropTypes.number.isRequired
};
export default Datepicker;



// WEBPACK FOOTER //
// ./src/components/shared/Date.jsx